import React from 'react';
import { Form, Input, Radio } from '@block/plug';
import Url from './url';
import { doAction } from '../../utils';
import './index.scss';

enum SickDictIndex {
  OTHER = '7',
}

interface Props {
  ref: any;
}

interface State {
  dataSource: any[];
  mainData: any[];
}
class HealthInfo extends React.Component<Props, State> {
  formRef = React.createRef<Form>();

  constructor(props: Props) {
    super(props);
    this.dataChanged = false;

    this.state = {
      dataSource: [],
      mainData: [],
    };
  }

  dataChanged: boolean;

  async componentDidMount() {
    const data = (await doAction(Url.getInfo, {}, null)) || [];
    this.initData(data);
  }

  initData = (data) => {
    const mainData = [...(data || [])];
    const obj = {};
    mainData.forEach((item) => {
      const { hasSick, sickDictIndex, memo } = item;
      const hasSickKey = `${sickDictIndex}-hasSick`;
      const memoKey = `${sickDictIndex}-memo`;
      // 健康信息表单项 《其他》， 默认勾选否
      if (sickDictIndex === SickDictIndex.OTHER) {
        obj[hasSickKey] = hasSick || 0;
      } else {
        obj[hasSickKey] = hasSick;
      }
      obj[memoKey] = memo;
    });
    this.setState({
      dataSource: data,
      mainData,
    });
    this.formRef.current?.setFieldsValue?.(obj);
  };

  handleFieldValueChange = (code: string, value: DefaultAny) => {
    const ref = this.formRef.current;
    const index = code.split('-')[0];
    if (code.indexOf('hasSick') > -1) {
      const sickDictIndex = index;
      ref?.setFieldsValue({
        [`${sickDictIndex}-memo`]: null,
      });
      this.handleStateChange(sickDictIndex, value, 'hasSick');
    }
    if (code.indexOf('memo') > -1) {
      const sickDictIndex = code.split('-')[0];
      this.handleStateChange(sickDictIndex, value, 'memo');
    }
    this.dataChanged = true;
  };

  handleStateChange = (sickDictIndex, value, type) => {
    this.setState((preState) => {
      const data = preState.dataSource.map((item) => {
        if (item.sickDictIndex === sickDictIndex) {
          item[type] = value;
          if (type === 'hasSick' && value === 0) {
            item.memo = null;
          }
        }
        return item;
      });
      return {
        dataSource: data,
      };
    });
  };

  // 保存
  handleSave = async () => {
    const ref = this.formRef.current;
    if (ref?.validateFields()) {
      const data = await doAction(Url.save, this.handleFetchFinalData());
      return data === undefined ? false : data;
    }
    return false;
  };

  // 获取最终组织数据
  handleFetchFinalData = () => {
    const { mainData } = this.state;
    return [...mainData];
  };

  render() {
    const { ref } = this.props;
    const { mainData } = this.state;
    if (!mainData || (mainData && mainData.length === 0)) return null;
    return (
      <div ref={ref} className="health">
        <Form ref={this.formRef} labelWidth="25em" onFieldValueChange={this.handleFieldValueChange}>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[0].sickDictIndex}-hasSick`}
            label={mainData[0].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[0].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[0].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>

          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[1].sickDictIndex}-hasSick`}
            label={mainData[1].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[1].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[1].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>

          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[2].sickDictIndex}-hasSick`}
            label={mainData[2].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[2].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[2].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>

          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[3].sickDictIndex}-hasSick`}
            label={mainData[3].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[3].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[3].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>

          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[4].sickDictIndex}-hasSick`}
            label={mainData[4].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[4].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[4].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>

          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[5].sickDictIndex}-hasSick`}
            label={mainData[5].sickDictName}
            labelPosition="top"
          >
            <Radio.Group toFormItem>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            required
            message="不能为空"
            formItemKey={`${mainData[5].sickDictIndex}-memo`}
            labelWidth={0}
            labelPosition="top"
            hide={mainData[5].hasSick !== 1}
          >
            <Input toFormItem />
          </Form.Item>
          {mainData?.[6] && (
            <Form.Item
              formItemKey={`${mainData[6].sickDictIndex}-hasSick`}
              label={mainData[6].sickDictName}
              labelPosition="top"
            >
              <Radio.Group toFormItem>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          {mainData?.[6] && (
            <Form.Item
              required
              message="不能为空"
              formItemKey={`${mainData[6].sickDictIndex}-memo`}
              labelWidth={0}
              labelPosition="top"
              hide={mainData[6].hasSick !== 1}
            >
              <Input toFormItem placeholder="如有其他疾病，请输入；如没有无需填写" />
            </Form.Item>
          )}
        </Form>
      </div>
    );
  }
}

export default HealthInfo;
